import * as yup from "yup";
import { loadTripCategories } from "../../../hooks/useTripCategories";
export var TripFieldConfig = {
    tripName: {
        fieldType: "Text",
        name: "tripName",
        label: "Trip Name",
        variant: "outlined",
        fullWidth: true,
        validation: yup.string().required("Trip Name is required"),
        color: "white",
        autoFocus: true,
    },
    tripCategories: {
        fieldType: "Select",
        name: "tripCategories",
        label: "Trip Categories",
        multiple: true,
        options: function () { return loadTripCategories(); },
        validation: yup
            .array()
            .of(yup.string())
            .min(1, "At least one category must be selected"),
        autoFocus: true,
    },
    modeOfTransport: {
        fieldType: "Select",
        name: "modeOfTransport",
        label: "Mode of Transport",
        options: [
            { value: "Car", label: "Car" },
            { value: "Bike", label: "Bike" },
            { value: "Train", label: "Train" },
            { value: "Flight", label: "Flight" },
        ],
        autoFocus: true,
        validation: yup.string().required("Mode of Transport is required"),
    },
    description: {
        fieldType: "Text",
        name: "description",
        label: "Description",
        variant: "outlined",
        type: "textarea",
        fullWidth: true,
        multiline: true,
        rows: 4,
        autoFocus: true,
        validation: yup.string().required("Description is required"),
    },
    source: {
        fieldType: "Text",
        name: "source",
        label: "Starting From",
        autoFocus: true,
        color: "white",
        validation: yup.string().required("Starting location is required"),
    },
    destination: {
        fieldType: "Text",
        name: "destination",
        label: "Destination",
        validation: yup.string().required("Destination is required"),
        autoFocus: true,
        color: "white",
    },
    startDate: {
        fieldType: "Date",
        name: "startDate",
        label: "Trip Start Date",
        validation: yup.date().required("Start date is required"),
        color: "white",
        autoFocus: true,
    },
    endDate: {
        fieldType: "Date",
        name: "endDate",
        label: "Returning On",
        validation: yup
            .date()
            .required("Returning date is required")
            .min(yup.ref("startDate"), "Return date must be after start date"),
        color: "white",
        autoFocus: true,
    },
    privacySetting: {
        fieldType: "Select",
        name: "privacySetting",
        label: "Privacy Setting",
        options: [
            { value: "invite-only", label: "Invite Only" },
            { value: "public", label: "Public" },
            { value: "approval", label: "Approval" },
        ],
        validation: yup.string().required("Privacy setting is required"),
        autoFocus: true,
    },
    maxParticipant: {
        fieldType: "Text",
        type: "number",
        name: "maxParticipant",
        label: "Max Participants",
        autoFocus: true,
        validation: yup
            .number()
            .required("Max participants is required")
            .min(1, "Must have at least 1 participant"),
    },
    // 🔹 NEW FIELDS BELOW
    highlights: {
        fieldType: "Text",
        name: "highlights",
        label: "Highlights",
        type: "textarea",
        fullWidth: true,
        multiline: true,
        rows: 3,
        autoFocus: true,
        validation: yup
            .string()
            .required("Highlights are required")
            .max(500, "Highlights should not exceed 500 characters"),
    },
    inclusions: {
        fieldType: "Text",
        name: "inclusions",
        type: "textarea",
        label: "Inclusions",
        fullWidth: true,
        multiline: true,
        rows: 3,
        autoFocus: true,
        validation: yup
            .string()
            .required("Inclusions are required")
            .max(500, "Inclusions should not exceed 500 characters"),
    },
    exclusions: {
        fieldType: "Text",
        name: "exclusions",
        label: "Exclusions",
        type: "textarea",
        fullWidth: true,
        multiline: true,
        rows: 3,
        autoFocus: true,
        validation: yup
            .string()
            .required("Exclusions are required")
            .max(500, "Exclusions should not exceed 500 characters"),
    },
    itinerary: {
        fieldType: "Text",
        name: "itinerary",
        label: "Itinerary",
        type: "textarea",
        fullWidth: true,
        multiline: true,
        rows: 5,
        autoFocus: true,
        validation: yup
            .string()
            .required("Itinerary details are required")
            .max(1000, "Itinerary should not exceed 1000 characters"),
    },
    itineraryDay: {
        fieldType: "Text",
        name: "day",
        label: "Day",
        autoFocus: true,
        validation: yup.string().required("Day is required"),
    },
    itineraryTitle: {
        fieldType: "Text",
        name: "title",
        label: "Title",
        autoFocus: true,
        validation: yup.string().required("Title is required"),
    },
    itineraryDescription: {
        fieldType: "Text",
        name: "description",
        type: "textarea",
        label: "Description",
        multiline: true,
        rows: 3,
        autoFocus: true,
        validation: yup.string().required("Description is required"),
    },
    meetingPoint: {
        fieldType: "Text",
        name: "locationDetails.meetingPoint",
        label: "Meeting Point",
        fullWidth: true,
        autoFocus: true,
        validation: yup
            .string()
            .required("Meeting point is required")
            .max(200, "Meeting point should not exceed 200 characters"),
    },
    meetingTime: {
        fieldType: "Text",
        name: "locationDetails.meetingTime",
        label: "Meeting Time",
        fullWidth: true,
        autoFocus: true,
        validation: yup
            .string()
            .required("Meeting time is required")
            .matches(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/, "Meeting time must be in YYYY-MM-DD HH:mm format"),
    },
};
